var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgVerified = function SvgVerified(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 16,
    fill: "none",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.7568 16C13.5333 16 17.4055 12.4183 17.4055 8C17.4055 3.58172 13.5333 0 8.7568 0C3.98029 0 0.108154 3.58172 0.108154 8C0.108154 12.4183 3.98029 16 8.7568 16Z",
    fill: "#36B37E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.60264 10.5495L5.25186 8.38801C5.18617 8.32725 5.15332 8.24913 5.15332 8.15364C5.15332 8.05815 5.18617 7.98003 5.25186 7.91927L5.77269 7.45052C5.83838 7.38107 5.92049 7.34635 6.01903 7.34635C6.11756 7.34635 6.20437 7.38107 6.27944 7.45052L7.85602 8.90885L11.2344 5.78385C11.3095 5.71441 11.3963 5.67969 11.4948 5.67969C11.5933 5.67969 11.6755 5.71441 11.7411 5.78385L12.262 6.2526C12.3277 6.31337 12.3605 6.39149 12.3605 6.48698C12.3605 6.58246 12.3277 6.66059 12.262 6.72135L8.10939 10.5495C8.0437 10.6189 7.95924 10.6536 7.85602 10.6536C7.75279 10.6536 7.66833 10.6189 7.60264 10.5495Z",
    fill: "white"
  })));
};
export default SvgVerified;